import { render, staticRenderFns } from "./ActivityStage.vue?vue&type=template&id=808365be&scoped=true&"
import script from "./ActivityStage.vue?vue&type=script&lang=js&"
export * from "./ActivityStage.vue?vue&type=script&lang=js&"
import style0 from "./ActivityStage.vue?vue&type=style&index=0&id=808365be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808365be",
  null
  
)

export default component.exports